module.exports = __webpack_public_path__ + "img/Frame-3.6b735e9.png";